module.exports = __webpack_public_path__ + "static/media/google-pay-mark.95f3d7cc.svg";